module.exports = __webpack_public_path__ + "static/media/videofx_vc-express-300x300.bb1600c6.jpg";